/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, CreatableSelectDropDown, SelectDropDown } from '@wot/components';
import { HorizontalTextInput } from '@wot/shared';
import { ITutorPersonalDetails } from '@wot/typings';
import { City, Country, State } from 'country-state-city';
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-date-picker';
import { useForm } from 'react-hook-form';
import { MdAdd } from 'react-icons/md';
// import 'react-phone-number-input/style.css';
import { LOADING } from '../../../../assets/animated';
import { CLOSE_ICON } from '../../../../assets/icons';
import { PROFILE_PIC_PLACEHOLDER } from '../../../../assets/images';
import PhoneNumberInput from '../../../../components/PhoneNumberInput/PhoneNumberInput';
import { useAppSelector } from '../../../../hooks/useRedux';
import { API_URL, LANGUAGES } from '../../../../utils/constants';
import ProfileIssues from '../../ProfileIssues';
import UploadFileInput from '../../UploadFileInput';
import './date_picker.css';
import './input_field.css';

let countries = Country.getAllCountries();

const genderOptions = ['male', 'female', 'other', 'prefer not to say'];

const idTypeOptions: string[] = ['Aadhaar', 'PAN', 'Driving License', 'Passport'];

interface Form {
  name: string;
  email: string;
  bio: string;
  houseno: string;
  street: string;
  city: string;
  state: string;
  pincode: string;
  name_in_id: string;
}

interface Props {
  personal?: ITutorPersonalDetails;
  onSave?: (data: ITutorPersonalDetails) => void;
  onSaveAndNext?: (data: ITutorPersonalDetails) => void;
  loading?: boolean;
}

function PersonalDetailsComponent({ loading, personal, onSave, onSaveAndNext }: Props) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<Form>();

  const tutor = useAppSelector((state) => state.authSlice.tutor);

  const [number, setNumber] = useState<string>('');
  const [phoneCount, setPhoneCount] = useState<number | null>(null);

  const [states, setStates] = useState<string[]>(['']);
  const [cities, setCities] = useState<string[]>(['']);

  const [country, setCountry] = useState<{ name: string; code: string }>({
    name: personal?.data?.address.country || '',
    code: ''
  });
  const [state, setState] = useState<{ name: string; code: string }>({
    name: personal?.data?.address.state || '',
    code: ''
  });
  const [city, setCity] = useState<{ name: string }>({ name: personal?.data?.address.city || '' });

  const [dob, setDob] = useState(new Date());
  const [gender, setGender] = useState<'male' | 'female' | 'other' | 'prefer not to say' | ''>('');
  const [languageList, setLanguageList] = useState<string[]>([]);

  const idFrontInput = useRef(document.createElement('input'));
  const idBackInput = useRef(document.createElement('input'));
  const panFrontInput = useRef(document.createElement('input'));
  const profilePicInput = useRef(document.createElement('input'));

  const [pfp, setPfp] = useState(personal?.data?.profilePic);
  const [selectedPfp, setSelectedPfp] = useState<File>();
  const [idFront, setIdFront] = useState(personal?.data?.aadhaarIdFrontImg);
  const [selectedIdFront, setSelectedIdFront] = useState<File>();
  const [idBack, setIdBack] = useState(personal?.data?.aadhaarIdBackImg);
  const [selectedIdBack, setSelectedIdBack] = useState<File>();
  const [panCardFront, setPanCardFront] = useState(personal?.data?.aadhaarIdFrontImg);
  const [selectedPanCardFront, setSelectedPanCardFront] = useState<File>();

  const [error, setError] = useState(false);

  useEffect(() => {
    let states = State.getStatesOfCountry(country.code).map((s) => s.name);
    setStates(states);
  }, [country]);
  useEffect(() => {
    let cities = City.getCitiesOfState(country.code, state.code).map((s) => s.name);
    setCities(cities);
  }, [country, state]);

  useEffect(() => {
    if (personal) {
      setValue('name', personal.data?.name);
      setValue('email', personal.data?.email);
      setValue('bio', personal.data?.bio);
      setValue('name_in_id', personal.data?.proofIdName);
      setValue('houseno', personal.data?.address.houseNo);
      setValue('street', personal.data?.address.street);
      setValue('city', personal.data?.address.city);
      setValue('state', personal.data?.address.state);
      setValue('pincode', personal.data?.address.pincode);
      setPhoneCount(personal.data?.phoneNumber.length);
      setPfp(personal.data?.profilePic);
      setIdFront(personal.data?.aadhaarIdFrontImg);
      setIdBack(personal.data?.aadhaarIdBackImg);
      setPanCardFront(personal.data?.panCardFrontImg);
      setNumber(personal.data?.phoneNumber);
      setCountry({
        name: personal.data?.address.country,
        code: countries.find((c) => c.name === personal.data?.address.country)?.isoCode || ''
      });
      setDob(new Date(personal.data?.dateOfBirth));
      setGender(personal.data?.gender);
      setLanguageList(personal.data?.languagesSpoken);
    }
  }, [personal]);

  const uploadImages = async () => {
    const urls = { pfp: '', idFront: '', idBack: '', panCardFront: '' };
    if (selectedPfp) {
      let formData = new FormData();
      formData.append('file', selectedPfp);
      await fetch(`${API_URL}/upload`, {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then(async (res) => {
          const picUrl = res.data;
          setPfp(picUrl);
          urls.pfp = picUrl;
        });
    }
    if (selectedIdFront) {
      let formData = new FormData();
      formData.append('file', selectedIdFront);
      await fetch(`${API_URL}/upload`, {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then(async (res) => {
          const idfPicUrl = res.data;
          setIdFront(idfPicUrl);
          urls.idFront = idfPicUrl;
        });
    }
    if (selectedIdBack) {
      let formData = new FormData();
      formData.append('file', selectedIdBack);
      await fetch(`${API_URL}/upload`, {
        // return await fetch("https://worldotutor-api.onrender.com/upload", {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then(async (res) => {
          const idbPicUrl = res.data;
          setIdBack(idbPicUrl);
          urls.idBack = idbPicUrl;
        });
    } else if (personal && personal.data?.aadhaarIdBackImg) {
      setIdBack(personal.data?.aadhaarIdBackImg);
    }

    if (selectedPanCardFront) {
      let formData = new FormData();
      formData.append('file', selectedPanCardFront);
      await fetch(`${API_URL}/upload`, {
        method: 'POST',
        body: formData
      })
        .then((res) => res.json())
        .then(async (res) => {
          const url = res.data;
          setPanCardFront(url);
          urls.panCardFront = url;
        });
    }
    return urls;
  };

  const validate = () => {
    if (
      !gender ||
      languageList.length === 0 ||
      (!idFront && !selectedIdFront) ||
      (!idBack && !selectedIdBack) ||
      phoneCount !== number.length
    ) {
      setError(true);
      return true;
    }
    setError(false);
    return false;
  };

  const generateData = async (data: any) => {
    const url = await uploadImages();
    const details: ITutorPersonalDetails = {
      data: {
        profilePic: url.pfp !== '' ? url.pfp : pfp || '',
        name: data.name,
        phoneNumber: number,
        email: data.email,
        bio: data.bio,
        dateOfBirth: dob.toISOString(),
        gender: gender || 'prefer not to say',
        address: {
          houseNo: data.houseno,
          street: data.street,
          city: city.name,
          state: state.name,
          pincode: data.pincode,
          country: country.name
        },
        languagesSpoken: languageList,
        proofIdName: data.name_in_id,
        aadhaarIdFrontImg: url.idFront !== '' ? url.idFront : idFront || '',
        aadhaarIdBackImg: url.idBack !== '' ? url.idBack : idBack || '',
        panCardFrontImg: url.panCardFront
      },
      status: personal?.status === 'verified' ? personal.status : 'pending',
      issues: []
    };
    return details;
  };

  useEffect(() => {
    setValue('email', tutor?.email || '');
  }, []);

  const onSubmit = async (data: any) => {
    let v = validate();
    if (v) {
      return;
    }
    let details = await generateData(data);
    onSave && onSave(details);
  };

  const onSubmitAndNext = async (data: any) => {
    let v = validate();
    if (v) {
      return;
    }
    let details = await generateData(data);
    onSaveAndNext && onSaveAndNext(details);
  };

  return (
    <div className=" w-full relative md:px-10 overflow-hidden">
      {personal?.status === 'issue' && personal.issues.length > 0 && <ProfileIssues issues={personal.issues} />}
      <form className="w-full h-full mt-6 mr-32" onSubmit={(e) => e.preventDefault()} encType="multipart/form-data">
        <div className="container mx-auto pr-4 pb-40 h-full overflow-y-scroll custom-scrollbar">
          <div className="w-full pb-4 flex flex-col items-center justify-center">
            {selectedPfp ? (
              <div className="group relative flex flex-col items-center justify-center h-24 w-24 object-cover rounded-full bg-gray-200 overflow-hidden">
                {selectedPfp && (
                  <img alt="not fount" className="w-full h-full object-cover" src={URL.createObjectURL(selectedPfp)} />
                )}
                <div className="group-hover:flex hidden absolute top-0 left-0 flex-col items-center justify-center h-24 w-24 object-cover rounded-full bg-gray-100/50">
                  <MdAdd className="w-4 h-4" />
                  <h3 className="uppercase text-black text-xs font-semibold">Edit</h3>
                  <input
                    type="file"
                    className="absolute z-10 w-full h-full cursor-pointer opacity-0"
                    onChange={(e) => {
                      setSelectedPfp((e.target.files && e.target.files?.length > 0 && e.target.files[0]) || undefined);
                    }}
                  />
                </div>
              </div>
            ) : pfp ? (
              <div className="group relative flex flex-col items-center justify-center h-24 w-24 object-cover rounded-full bg-gray-200 overflow-hidden">
                <img alt="not fount" className="w-full h-full object-cover" src={pfp} />
                <div className="group-hover:flex hidden absolute top-0 left-0 flex-col items-center justify-center h-24 w-24 object-cover rounded-full bg-gray-100/50">
                  <MdAdd className="w-4 h-4" />
                  <h3 className="uppercase text-black text-xs font-semibold">Edit</h3>
                  <input
                    type="file"
                    className="absolute z-10 w-full h-full cursor-pointer opacity-0"
                    onChange={(e) => {
                      // @ts-ignore
                      setSelectedPfp((e.target.files && e.target.files?.length > 0 && e.target.files[0]) || undefined);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="w-full flex flex-col items-center justify-center">
                <img
                  src={PROFILE_PIC_PLACEHOLDER}
                  alt="Profile Picture"
                  className="h-24 w-24 object-cover rounded-full"
                />
                <input
                  type="file"
                  accept="image/*"
                  ref={profilePicInput}
                  style={{ display: 'none' }}
                  required
                  onChange={(e) => {
                    // @ts-ignore
                    setSelectedPfp(e.target.files[0]);
                  }}
                />
                <p
                  className="py-1 font-medium text-primary cursor-pointer"
                  onClick={() => profilePicInput.current.click()}
                >
                  Add Profile Picture
                </p>
              </div>
            )}
          </div>
          <HorizontalTextInput
            errors={errors}
            label={'Name'}
            name={'name'}
            placeholder={'John Doe'}
            register={register}
            type="text"
            required={'Please enter your Name'}
          />

          <div className="py-3 flex flex-col lg:flex-row lg:items-center items-start gap-4">
            <p className="lg:w-2/5 w-full">Phone Number</p>
            <div className=" w-full flex flex-col">
              <PhoneNumberInput
                value={number}
                containerStyle={{ margin: 0 }}
                setValue={setNumber}
                setPhoneCount={setPhoneCount}
              />
              {error && (
                <p className="text-xs font-medium text-red-400">
                  {phoneCount !== number.length && 'Please Enter Correct Phone Number'}
                </p>
              )}
            </div>
          </div>

          <HorizontalTextInput
            errors={errors}
            label={'Email ID'}
            name={'email'}
            placeholder={'email@example.com'}
            register={register}
            value={tutor?.email}
            disabled={true}
            type="email"
            required={'Please enter the Email Id'}
          />
          <div className="w-full py-3 flex flex-col lg:flex-row lg:items-center items-start gap-4">
            <p className="lg:w-2/5 w-full">Bio</p>
            <div className="w-full flex flex-col">
              <textarea
                {...register('bio', {
                  required: { value: true, message: 'Please Provide your Bio' }
                })}
                id="bio"
                cols={30}
                rows={4}
                name="bio"
                maxLength={800}
                placeholder="Max 800 characters"
                className="w-full px-4 py-2 border border-neutralBlue1 rounded-md"
              ></textarea>
              {errors['bio'] && (
                <p className="text-xs font-medium text-red-400">
                  <>{errors['bio'].message}</>
                </p>
              )}
            </div>
          </div>

          <h2 className="font-medium text-xl my-5">Add Address</h2>
          <div className="flex flex-col gap-4">
            <HorizontalTextInput
              errors={errors}
              label={'Flat, House no., Building'}
              name={'houseno'}
              placeholder={'5, Skyline Apartment'}
              register={register}
              type="text"
              required={''}
            />
            <HorizontalTextInput
              errors={errors}
              label={'Area/Street'}
              name={'street'}
              placeholder={'Pahar Ganj'}
              register={register}
              type="text"
              required={'Area/Street is required'}
            />
            <HorizontalTextInput
              errors={errors}
              label={'Pincode'}
              name={'pincode'}
              placeholder={'110001'}
              register={register}
              type="number"
              required={'Pincode is required'}
            />
            <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4 py-2">
              <p className="lg:w-2/5 w-full">Country</p>
              <div className="w-full flex flex-col">
                <SelectDropDown
                  placeholder="Country"
                  value={country.name}
                  options={countries.map((c) => c.name)}
                  onChange={(value) =>
                    setCountry({ name: value, code: countries.find((c) => c.name == value)?.isoCode || '' })
                  }
                  isSearchable
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">{!country.name && 'Please Select your Country'}</p>
                )}
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4 py-2">
              <p className="lg:w-2/5 w-full">State</p>
              <div className="w-full flex flex-col">
                <SelectDropDown
                  placeholder="State"
                  value={state.name}
                  options={states}
                  onChange={(value) =>
                    setState({
                      name: value,
                      code: State.getStatesOfCountry(country.code).find((c) => c.name == value)?.isoCode || ''
                    })
                  }
                  isSearchable
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">{!state.name && 'Please Select your State'}</p>
                )}
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4 py-2">
              <p className="lg:w-2/5 w-full">Town/City</p>
              <div className="w-full flex flex-col">
                <SelectDropDown
                  placeholder="City"
                  value={city.name}
                  options={cities}
                  onChange={(value) => setCity({ name: value })}
                  isSearchable
                />
                {error && <p className="text-xs font-medium text-red-400">{!city.name && 'Please Select your City'}</p>}
              </div>
            </div>
          </div>

          <h2 className="font-medium text-xl my-5">Other personal details</h2>
          <div className="flex flex-col gap-4">
            <div className="w-full flex flex-col lg:flex-row lg:items-center items-start gap-4">
              <p className="lg:w-2/5 w-full">Date of Birth</p>
              <div className="w-full">
                <DatePicker onChange={setDob} value={new Date(dob)} format="dd/MM/y" />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4">
              <p className="lg:w-2/5 w-full">Gender</p>
              <div className="w-full flex flex-col">
                <SelectDropDown
                  placeholder="Gender"
                  value={gender}
                  options={genderOptions}
                  onChange={(value: any) => setGender(value)}
                />
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center items-start gap-4 justify-start">
              <p className="lg:w-2/5 w-full">Languages Spoken</p>
              <div className="w-full flex flex-col">
                <CreatableSelectDropDown
                  placeholder="Languages Spoken"
                  isMulti
                  values={languageList}
                  options={LANGUAGES}
                  onChange={(values) => setLanguageList(values as string[])}
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">
                    {languageList.length === 0 && 'Please Select Your Languages'}
                  </p>
                )}
              </div>
            </div>

            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <p className="w-full md:w-2/5">{`Aadhaar Front`}</p>
              <div className="w-full mr-4 flex flex-col">
                <UploadFileInput>
                  <>
                    <div
                      onClick={() => idFrontInput.current.click()}
                      className="pr-4 w-full h-[90%] flex flex-row items-center justify-between overflow-hidden"
                    >
                      {idFront || selectedIdFront ? (
                        <img
                          src={selectedIdFront?.name ? URL.createObjectURL(selectedIdFront) : idFront}
                          className="h-full object-contain overflow-hidden"
                          alt={idFront}
                        />
                      ) : (
                        'Click to Upload'
                      )}
                    </div>
                    {idFront && (
                      <img
                        src={CLOSE_ICON}
                        alt=""
                        className="h-3 mx-2"
                        onClick={() => {
                          setSelectedIdFront(undefined);
                          setIdFront(undefined);
                        }}
                      />
                    )}
                  </>
                </UploadFileInput>
                <input
                  type="file"
                  accept="image/*"
                  ref={idFrontInput}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    // @ts-ignore
                    setSelectedIdFront(e.target.files[0]);
                  }}
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">
                    {!idFront && !selectedIdFront && 'Please Upload front image of your aadhaar'}
                  </p>
                )}
              </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <p className="w-full md:w-2/5">{`Aadhaar Back`}</p>
              <div className="w-full mr-4 flex flex-col">
                <UploadFileInput>
                  <>
                    <div
                      onClick={() => idBackInput.current.click()}
                      className="pr-4 w-full h-[90%] flex flex-row items-center justify-between overflow-hidden"
                    >
                      {idBack || selectedIdBack ? (
                        <img
                          src={selectedIdBack?.name ? URL.createObjectURL(selectedIdBack) : idBack}
                          className="h-full object-contain overflow-hidden"
                          alt={idBack}
                        />
                      ) : (
                        'Click to Upload'
                      )}
                    </div>
                    {idBack && (
                      <img
                        src={CLOSE_ICON}
                        alt=""
                        className="h-3 mx-2"
                        onClick={() => {
                          setSelectedIdBack(undefined);
                          setIdBack(undefined);
                        }}
                      />
                    )}
                  </>
                </UploadFileInput>
                <input
                  type="file"
                  accept="image/*"
                  ref={idBackInput}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    // @ts-ignore
                    setSelectedIdBack(e.target.files[0]);
                  }}
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">
                    {!idBack && !selectedIdBack && 'Please Upload Back image of your aadhaar'}
                  </p>
                )}
              </div>
            </div>

            <div className="flex flex-col md:flex-row md:items-center gap-4">
              <p className="w-full md:w-2/5">{`Pan Card Front`}</p>
              <div className="w-full mr-4 flex flex-col">
                <UploadFileInput>
                  <>
                    <div
                      onClick={() => panFrontInput.current.click()}
                      className="pr-4 w-full h-[90%] flex flex-row items-center justify-between overflow-hidden"
                    >
                      {panCardFront || selectedPanCardFront ? (
                        <img
                          src={selectedPanCardFront?.name ? URL.createObjectURL(selectedPanCardFront) : panCardFront}
                          className="h-full object-contain overflow-hidden"
                          alt={panCardFront}
                        />
                      ) : (
                        'Click to Upload'
                      )}
                    </div>
                    {panCardFront && (
                      <img
                        src={CLOSE_ICON}
                        alt=""
                        className="h-3 mx-2"
                        onClick={() => {
                          setSelectedPanCardFront(undefined);
                          setPanCardFront(undefined);
                        }}
                      />
                    )}
                  </>
                </UploadFileInput>
                <input
                  type="file"
                  accept="image/*"
                  ref={panFrontInput}
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    // @ts-ignore
                    setSelectedPanCardFront(e.target.files[0]);
                  }}
                />
                {error && (
                  <p className="text-xs font-medium text-red-400">
                    {!panCardFront && !selectedPanCardFront && 'Please Upload Front image of your pan card'}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="absolute z-40 bottom-0 bg-white w-full py-7 flex flex-row items-center justify-center border-t">
          {loading ? (
            <div className="w-full flex items-center justify-center">
              <img src={LOADING} className="w-10 h-10" />
            </div>
          ) : (
            <>
              <div className="w-full md:max-w-[164px] mx-2">
                <Button loading={loading} block text={'Save'} role="submit" onClick={handleSubmit(onSubmit)} />
              </div>
              {onSaveAndNext && (
                <div className="w-full md:max-w-[164px] mx-2">
                  <Button
                    loading={loading}
                    block
                    role="submit"
                    text={'Save & Next'}
                    onClick={handleSubmit(onSubmitAndNext)}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </form>
    </div>
  );
}

export default PersonalDetailsComponent;
